<template>
  <div class="page">
    <Header06 v-if="month === '202006'">
      <template #title>
        <span>{{ liveDate }}</span>
        {{ title }}
      </template>
    </Header06>
    <Header07 v-if="month === '202007'">
      <template #title>
        <span>{{ liveDate }}</span>
        {{ title }}
      </template>
    </Header07>
    <Header08 v-if="month === '202008'">
      <template #title>
        <span>{{ liveDate }}</span>
        {{ title }}
      </template>
    </Header08>
    <Header10tsuruha v-if="month === '202010'">
      <template #title>
        <span>{{ liveDate }}</span>
        {{ title }}
      </template>
    </Header10tsuruha>
    <div v-if="month === '202006'">
      <LiveDetail06
        :program="livePage"
        :liveType="liveType"
      />
    </div>
    <div v-if="month === '202007'">
      <LiveDetail07
        :program="livePage"
        :liveType="liveType"
      />
    </div>
    <div v-if="month === '202008'">
      <LiveDetail08
        :program="livePage"
        :liveType="liveType"
      />
    </div>
    <div v-if="month === '202010'">
      <LiveDetail10tsuruha
        :program="livePage"
        :liveType="liveType"
      />
    </div>
    <Floating
      floatingType="tools"
    >
      <template #content>
        <WatchButton
          :program="livePage"
          :liveType="liveType"
        />
      </template>
    </Floating>
    <div v-if="month === '202010'">
      <Floating
        floatingType="tools"
      >
        <template #content>
          <WatchButton10tsuruha
            v-if="liveType === 'provider'"
            :program="livePage"
            :liveType="liveType"
          />
          <WatchButton
            v-else
            :program="livePage"
            :liveType="liveType"
          />
        </template>
      </Floating>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Header06 from '@/components/organisms/202006/Header.vue'
import Header07 from '@/components/organisms/202007/Header.vue'
import Header08 from '@/components/organisms/202008/Header.vue'
import Header10tsuruha from '@/components/organisms/202010tsuruha/Header.vue'
import LiveDetail06 from '@/components/organisms/202006/live/LiveDetail.vue'
import LiveDetail07 from '@/components/organisms/202007/live/LiveDetail.vue'
import LiveDetail08 from '@/components/organisms/202008/live/LiveDetail.vue'
import LiveDetail10tsuruha from '@/components/organisms/202010tsuruha/live/LiveDetail.vue'
import Floating from '@/components/molecules/Floating.vue'
import WatchButton from '@/components/atoms/WatchButton.vue'
import WatchButton10tsuruha from '@/components/atoms/202010tsuruha/WatchButton.vue'

export default {
  name: 'live',
  components: {
    Header06,
    Header07,
    Header08,
    Header10tsuruha,
    LiveDetail06,
    LiveDetail07,
    LiveDetail08,
    LiveDetail10tsuruha,
    Floating,
    WatchButton,
    WatchButton10tsuruha
  },
  computed: {
    ...mapState([
      'livePage',
      'liveType'
    ]),
    docId () {
      return this.$route.params.docId
    },
    title () {
      return this.liveType === 'company' ? this.livePage.eventname : this.livePage.title
    },
    month () {
      return this.$route.params.month
    }
  },
  async mounted () {
    await this.getLivePage()
    document.title = 'LIVE - リトル・ママオンラインフェスタ'
  },
  data: () => ({
    liveDate: ''
  }),
  methods: {
    ...mapMutations([
      'setLastCompanySnapshots',
      'setLastProviderSnapshots'
    ]),
    ...mapActions([
      'getCompanyLivePage',
      'getProviderLivePage'
    ]),
    async getLivePage () {
      this.setLastCompanySnapshots(null)
      this.setLastProviderSnapshots(null)
      await this.getCompanyLivePage({
        docId: this.docId,
        month: this.month
      })
    },
    setLiveDateState () {
      let schedules0624 = false
      let schedules0625 = false
      let schedules0728 = false
      let schedules0729 = false
      let schedules0827 = false
      let schedules0828 = false
      let schedules1002 = false
      let schedules1003 = false
      if (this.livePage.deliveryFrame) {
        if (this.month === '202006') {
          schedules0624 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) <= 10
          })
          schedules0625 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) >= 11
          })
        }
        if (this.month === '202007') {
          schedules0728 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) <= 10
          })
          schedules0729 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) >= 11
          })
        }
        if (this.month === '202008') {
          schedules0827 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) <= 10
          })
          schedules0828 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) >= 11
          })
        }
        if (this.month === '202010') {
          schedules1002 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) <= 9
          })
          schedules1003 = this.livePage.deliveryFrame.filter((frame) => {
            return Number(frame) >= 10
          })
        }
      }
      if (typeof schedules0624 === 'object' && typeof schedules0625 === 'object') {
        if (schedules0624.length > 0 && schedules0625.length > 0) {
          this.liveDate = '6月24日(水)、6月25日(木)'
        } else if (schedules0624.length > 0) {
          this.liveDate = '6月24日(水)'
        } else {
          this.liveDate = '6月25日(木)'
        }
      } else if (typeof schedules0728 === 'object' && typeof schedules0729 === 'object') {
        if (schedules0728.length > 0 && schedules0729.length > 0) {
          this.liveDate = '7月28日(火)、7月29日(水)'
        } else if (schedules0728.length > 0) {
          this.liveDate = '7月28日(火)'
        } else {
          this.liveDate = '7月29日(水)'
        }
      } else if (typeof schedules0827 === 'object' && typeof schedules0828 === 'object') {
        if (schedules0827.length > 0 && schedules0828.length > 0) {
          this.liveDate = '8月27日(木)、8月28日(金)'
        } else if (schedules0827.length > 0) {
          this.liveDate = '8月27日(木)'
        } else {
          this.liveDate = '8月28日(金)'
        }
      } else if (typeof schedules1002 === 'object' && typeof schedules1003 === 'object') {
        if (schedules1002.length > 0 && schedules1003.length > 0) {
          this.liveDate = '10月02日(金)、10月03日(土)'
        } else if (schedules1002.length > 0) {
          this.liveDate = '10月02日(金)'
        } else {
          this.liveDate = '10月03日(土)'
        }
      }
    }
  },
  watch: {
    'livePage.deliveryFrame': {
      handler (val, old) {
        this.setLiveDateState()
      },
      deep: true
    }
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 80px 0 100px
</style>
